import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import { EditOutlined, SettingOutlined, LineChartOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'
import { CourseContext } from '../Course/CourseContext'
import { FlexRow } from '../FlexboxReusables/FlexItems'
import Modal from '../Modal/Modal'

interface CourseActionsProps {
  courseId: number
}

const PublishedCourseActions: React.FC<CourseActionsProps> = ({ courseId }) => {
  const [ showModal, setShowModal ] = useState(false)

  const { deleteCourse } = useContext(CourseContext)
  const intl = useIntl()

  const handleConfirmDelete = () => {
    deleteCourse(courseId, intl)
    setShowModal(false)
  }

  return (
    <>
      <Modal
        title={intl.formatMessage({ id: 'course.deleteCourse' }) + '?'}
        open={showModal}
        onOk={handleConfirmDelete}
        onCancel={() => setShowModal(false)}
        message={<FormattedMessage id="editor.settings.areYouSureYouWantToDelete"/>}
      />
      <FlexRow justifyContent='space-evenly'>
        <Tooltip title={<FormattedMessage id="generic.settings" />}>
          <SettingOutlined key="setting" />
        </Tooltip>
        <Tooltip title={<FormattedMessage id="generic.edit" />}>
          <EditOutlined key="edit" />
        </Tooltip>
        <Tooltip title='Statistiken'> {/* INTL!!!!!! */}
          <Link to={`/published-course/${courseId}`}> {/* ROUTER PROPS ID!!!! */}
            <LineChartOutlined key="checkSquare" onClick={() => setShowModal(true)} />
          </Link>
        </Tooltip>
      </FlexRow>
    </>
  )
}

export default PublishedCourseActions
